<template>
	<component
		v-if="selectedBackground"
		:is="backgroundType"
		ref="el"
		:asset="selectedBackground"
		:autoplay="autoplay"
		:playsinline="playsinline"
		:muted="muted"
		:sizes="sizes"
		:fetchpriority="fetchpriority"
		data-component="media-asset"
		class="media"
	/>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

// import { ImageAsset, VideoAsset } from '~/components/core'

const props = defineProps({
	media: { type: [Boolean, Array, Object], default: false },
	autoplay: { type: [Boolean], default: true },
	muted: { type: [Boolean], default: true },
	playsinline: { type: [Boolean], default: true },
	sizes: {
		type: [Object, String],
		default: 'sizes="xsmall:400px medium:1200px xlarge:1700px"',
	},
	fetchpriority: { type: String, default: '' },
})
const el = ref(null)

const ImageAsset = defineAsyncComponent(() => import('~/components/core/ImageAsset/ImageAsset.vue'))
const VideoAsset = defineAsyncComponent(() => import('~/components/core/VideoAsset/VideoAsset.vue'))

const normalizedMedia = computed(() => {
	if (Array.isArray(props.media)) {
		return props.media.filter((item) => item && typeof item === 'object')
	}

	if (props.media && typeof props.media === 'object') {
		return [props.media]
	}

	return []
})

const selectedBackground = computed(() => {
	return normalizedMedia.value.find((item) => item.type === 'video') || normalizedMedia.value[0] || null
})

const backgroundType = computed(() => (selectedBackground.value?.type === 'video' ? VideoAsset : ImageAsset))

// defineExpose({ play: el.value?.play(), pause: el.value?.pause() })
</script>

<style lang="scss" scoped>
[data-component='media-asset'] {
	position: relative;
}
</style>
